module.exports = __webpack_public_path__ + "35f762e1754177d2ed024002950f161b.pdf";